import { Sites } from '@ps/platform-message-framework/common/Sites';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Url from 'url-parse';

import type { Props } from '@swf/components/Iframe/Iframe';
import Iframe from '@swf/components/Iframe/Iframe';
import { dispatch, select } from '@swf/core/store';

export interface IdpMessageData {
  origin: string;
  data: {
    access_token?: string;
    token_type?: string;
  };
}

const IdpClientProvider: React.FC<Props> = ({ children }) => {
  const siteId = useSelector(select.cms.getSiteId);
  const locationUrl = new Url(useSelector(select.location.getHref), true);
  const { apiDomain } = useSelector(select.config.get);
  const { code, redirect_uri: redirectUri } = locationUrl.query;
  const isDesktopEmbedded = useSelector(select.device.isDesktopEmbedded);
  const isPreviouslyAuthenticated = useSelector(select.session.isClientAuthenticated);

  const idpMessageListener = async ({ data }: IdpMessageData) => {
    if (data.access_token && data.token_type === 'Bearer') {
      dispatch.session.update({ idpToken: data.access_token });
      await dispatch.auth.verifySession();
      if (!isPreviouslyAuthenticated) {
        dispatch.cms.fetchPage({ href: window.location.href });
      }
    }
  };

  useEffect(() => {
    window.addEventListener('message', idpMessageListener);
    return () => window.removeEventListener('message', idpMessageListener);
  });

  if (siteId !== Sites.IT_SISAL_EXT || isDesktopEmbedded || !apiDomain) {
    return <>{children}</>;
  }

  const iframeSrcUrl = new URL(`${apiDomain}/oauth2/client`);
  code && iframeSrcUrl.searchParams.append('code', code);
  redirectUri && iframeSrcUrl.searchParams.append('redirect_uri', redirectUri);

  return (
    <>
      <Iframe title="IDP Client" src={iframeSrcUrl.toString()} style={{ display: 'none' }} />
      {children}
    </>
  );
};

export default IdpClientProvider;
